import { render } from "./SmallInfoBox.vue?vue&type=template&id=86df7b76"
import script from "./SmallInfoBox.vue?vue&type=script&lang=js"
export * from "./SmallInfoBox.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__